import HeroSection from './HeroSection';
import '../../styles/Home.css'; // Home ki CSS
import SportsSection from './SportsSection';
import EventsSection from './EventsSection';
import AboutSection from './AboutSection';
import FAQSection from './FAQSection';
import CTASection from './CTASection';

function Home() {
  return (
    <div className="home-wrapper">
      <HeroSection />
     <SportsSection/>
     <EventsSection/>
     <AboutSection/>
     <FAQSection/>
     <CTASection/>
    </div>
  );
}

export default Home;